import React from 'react';
import { useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ArcIconButton, ArcStack, ArcTooltip } from '@src/core/ui';
import { ReactComponent as RullerIcon } from '@src/assets/icons/ruller.svg';
import { selectRulerActive, setRulerActive } from '@src/core/controllers/map/redux';


const Ruller: React.FC = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const open = useSelector(selectRulerActive);

  const toggle = () => dispatch(setRulerActive(!open));

  const bgColor = open ? 'white' : 'background.paper';

  const iconColor = open ? theme.palette.background.paper : theme.palette.common.white;
  return (
    <ArcStack
      width={50}
      height={50}
      borderRadius={2}
      alignItems='center'
      justifyContent='center'
      bgcolor={bgColor}
      sx={{ position: 'relative', '& path': { fill: iconColor } }}
      onClick={toggle}>
      <ArcTooltip title='Ruller'>
        <ArcIconButton>
          <RullerIcon />
        </ArcIconButton>
      </ArcTooltip>
    </ArcStack>
  );
};

export default Ruller;